<template>
  <naj-box :title="local.arbitrationLawsuit.title">
    <v-row>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.number"
          :label="local.arbitrationLawsuit.arbitrationRequestCode"
          :value.sync="formModel.arbitrationRequestCode"
          :validates="`required|long|max:10|min:9|isVerified:${!!(formModel || {}).arbitrationText}`"
          @input="onRequestCodeChanged"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.arbitrationRequestCode"
        cols="3"
        align-self="center"
        class="text-right"
      >
        <naj-button
          square
          inputs-alignment
          :loading="isChecking"
          :disabled="isChecked"
          @click="check"
        >
          {{ local.personInformation.check }}
        </naj-button>
      </v-col>
      <v-col
        v-if="!isChecking && isChecked && formModel.isVerified"
        class="align-self-center the-rank"
      >
        <naj-error-text
          :text="arbitrationCheckSubject"
          size="medium"
          no-margin
        ></naj-error-text>
      </v-col>
    </v-row>
    <v-row v-if="!isChecking && isChecked && formModel.isVerified">
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.textarea"
          :label="local.arbitrationLawsuit.arbitrationText"
          :value.sync="formModel.arbitrationText"
          :disabled="true"
          :counter="100000"
        ></naj-input>
      </v-col>

      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.date"
          :label="local.arbitrationLawsuit.arbitrationDate"
          :value.sync="formModel.arbitrationDate"
          item-text="name"
          item-value="id"
          :disabled="true"
        ></naj-input>
      </v-col>
    </v-row>
  </naj-box>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { attachmentType, attachmentCategory } from '@/helpers/enum';
const { mapActions: mapLawsuitActions } = createNamespacedHelpers('LawsuitModule');
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'PreviousArbitrationInsertion',
  inject: ['$validator'],
  props: ['formModel'],
  data() {
    return {
      isChecking: false,
      isChecked: false,
      attachments: [],
    };
  },
  created() {
    if (this.formModel?.arbitrationRequestCode)
      this.check();
    this.isChecked = !!this.formModel.arbitrationRequestCode;
  },
  methods: {
    ...mapLawsuitActions(['getArbitrationAward']),
    ...mapGlobalActions(['handleAttachments']),
    onRequestCodeChanged() {
      this.isChecked = false;
      this.changeVerification(false);
      this.$set(this.formModel, 'arbitrationText', null);
      this.$set(this.formModel, 'arbitrationDate', null);
    },
    check() {
      this.isChecking = true;
      this.isChecked = true;
      const payLoad = this.formModel.arbitrationRequestCode;
      this.getArbitrationAward(payLoad)
        .then((response) => {
          this.processArbitrationAwardResponse(response);
        })
        .catch((error) => {
          this.processErrorResponse(error);
        });
    },
    processArbitrationAwardResponse(response) {
      this.isChecking = false;
      if (response && response.status === 200) {
        this.updateFormModelWithResponse(response.data);
        this.changeVerification(true);
        this.processAttachmentsIfAny(response.data.attachmentList);
        this.arbitrationCheckSubject = response.data.attachmentList.length > 0 ? this.local.arbitrationLawsuit.verificationSucceededUploadSucceeded : this.local.arbitrationLawsuit.verificationSucceededUploadFailed;
      }
    },
    updateFormModelWithResponse(data) {
      this.$set(this.formModel, 'arbitrationText', data.arbitrationText);
      this.$set(this.formModel, 'arbitrationDate', data.arbitrationDate);
    },
    processAttachmentsIfAny(attachmentList) {
      let attachments = [];
      (attachmentList || []).map((att) => {
        const extension = att.fileName.includes('.') ? '.' + att.fileName.split('.')
          .pop() : '.pdf';
        const fileType = extension === '.pdf' ? attachmentType.pdf : attachmentType.image;
        const attachment = {
          fileName: att.fileName,
          fileType,
          fileCategory: attachmentCategory.arbitrationJudgement,
          extension,
          sharePointId: att.sharePointId,
          isAttachmentAudited: true,
        };
        attachments.push(attachment);
      });
      return this.handleAttachments({
        attachments,
        fileCategory: attachmentCategory.arbitrationJudgement,
      });
    },
    processErrorResponse(err) {
      if (err.response.status === 404)
        this.toaster.error(this.local.arbitrationLawsuit.requestCodeNotFound);
      this.$set(this.formModel, 'arbitrationText', null);
      this.$set(this.formModel, 'arbitrationDate', null);
      this.changeVerification(false);
      this.isChecking = false;
      return;
    },
    changeVerification(isVerified) {
      this.$set(this.formModel, 'isVerified', isVerified);
    },
  },
};
</script>
